module.exports = __webpack_public_path__ + "img/prioritas_dg_k.049eef41.png";